import { createContext, ReactNode, useContext, useReducer } from "react";

// Create Context
interface AccreditationContextValue {
  acraFiles: File[];
  setAcraFiles: (files: File[]) => void;
  clearAcraFiles: () => void;
}

const initialState: AccreditationContextValue = {
  acraFiles: [],
  setAcraFiles: () => {},
  clearAcraFiles: () => {},
};

const actions = {
  SET_ACRA_FILES: "SET_ACRA_FILES",
  CLEAR_ACRA_FILES: "CLEAR_ACRA_FILES",
};

const reducer = (state: AccreditationContextValue, action: any) => {
  switch (action.type) {
    case actions.SET_ACRA_FILES:
      return {
        ...state,
        acraFiles: action.files,
      };
    case actions.CLEAR_ACRA_FILES:
      return {
        ...state,
        acraFiles: [],
      };
    default:
      return state;
  }
};

const AccreditationContext =
  createContext<AccreditationContextValue>(initialState);

export function AccreditationContextProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setAcraFiles = (files: File[]) => {
    dispatch({ type: actions.SET_ACRA_FILES, files });
  };

  const clearAcraFiles = () => {
    dispatch({ type: actions.CLEAR_ACRA_FILES });
  };

  const value: AccreditationContextValue = {
    acraFiles: state.acraFiles,
    setAcraFiles,
    clearAcraFiles,
  };

  return (
    <AccreditationContext.Provider value={value}>
      {children}
    </AccreditationContext.Provider>
  );
}

export function useAccreditationContext() {
  return useContext(AccreditationContext);
}
